import handleDocumentClick from '../../common/handle-document-click'

export default () => {
  const unsubscribers = []
  const documentElements = document.querySelectorAll(
    '[data-behaviour~="export-select-from-documents"]'
  )

  documentElements.forEach((documentElement) => {
    documentElement.addEventListener('click', handleDocumentClick)

    unsubscribers.push(() =>
      documentElement.removeEventListener('click', handleDocumentClick)
    )
  })

  return () => unsubscribers.forEach((unsubscribe) => unsubscribe())
}
